//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Routing.js";
import "../no/Builder.js";
import "../no/SelectNXObject.js";
import "../no/SelectObject.js";
let d=[[[1,"FirstRun",0,"SelectNXObject",0],[0,"RunAttributes",1,0],[0,"RunName",1,0],[1,"SecondRun",0,"SelectNXObject",0]],[[["objects","buttonType"],"ModifyItemsButton",{},2,0]],[]];
SPLM.Routing.IntegrateRunsBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Routing.IntegrateRunsBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Routing.IntegrateRunsBuilder.Enum = Object.freeze({
    "FirstRun" : "FirstRun", "SecondRun" : "SecondRun"});

SPLM.Routing.IntegrateRunsBuilder.Button = Object.freeze({
    "FromItems" : "FromItems", "ToItems" : "ToItems", "MemberItems" : "MemberItems", "Unknown" : "Unknown"});

export default SPLM;